module.exports = __webpack_public_path__ + "static/media/appsidex.acbe04c1.png";